import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { NewsService } from '../../services/news-service';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { AddNewsComponent } from '../add-news/add-news.component';
import { GetNewsDetailsComponent } from '../get-news-details/get-news-details.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as momentHijri from 'moment-hijri';
import { PagingService } from '../../../../shared/Services/PagingService';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
})
export class GetNewsComponent extends BaseComponent implements OnInit {
  form: FormGroup;

  dateFrom: string;
  dateTo: string;

  constructor(
    public service: NewsService,
    route: Router,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private fb: FormBuilder,
    private paging: PagingService
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    this.intitForm();
    this.loadEntities();
  }

  intitForm() {
    this.form = this.fb.group({
      titleAR: [''],
    });
  }

  handleSearch() {
    if (!this.form.value.titleAR && !this.dateFrom && !this.dateTo) {
      this.toast.danger('برجاءاختيار الاسم او التاريخ لاتمام عمليةالبحث', 'رساله تحذيرية');
      return;
    }

    let serchTermArr = [];

    if (this.form.value.titleAR.trim()) {
      let title = this.form.value.titleAR.trim();
      this.form.controls['titleAR'].setValue(title);
      serchTermArr.push(`titleAR:${title}`);
    }

    if (this.dateFrom) {
      let dateInput = document.getElementById('dateFrom') as HTMLInputElement;
      let modifiedDate = new Date(dateInput.value);
      let dateFrom = new Date(modifiedDate.toString().split('GMT')[0].concat('GMT+0000')).toISOString().split('T')[0];
      serchTermArr.push(`createdAt:>${dateFrom}`);
    }
    if (this.dateTo) {
      let dateInput = document.getElementById('dateTo') as HTMLInputElement;
      let modifiedDate = new Date(dateInput.value);
      let dateTo = new Date(modifiedDate.toString().split('GMT')[0].concat('GMT+0000')).toISOString().split('T')[0];
      serchTermArr.push(`createdAt:<${dateTo}`);
    }

    this.loadEntitiesWithFilter(serchTermArr.join(','));
  }
  clearFilter() {
    this.dateFrom = '';
    this.dateTo = '';
    this.form.controls['titleAR'].setValue('');
    this.loadEntitiesWithFilter('');
  }

  addNews() {
    this.diag
      .open(AddNewsComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }

  detail(model) {
    this.diag.open(GetNewsDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddNewsComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

  getHijriDate(date) {
   return momentHijri(date, 'YYYY-MM-DD').format('iYYYY/iM/iD');
  }
}
